import { useQuery } from 'react-query';
import firebase from '@config/firebase.config';
import { fetchSessionUrlActivities } from '@services/urlTrackingService';
import { queryKeys } from '@config/queryKeys';

const db = firebase.firestore();

const STALE_MS = 5 * 60 * 1000;

export function useSessionUrlActivities(
  teamId,
  userId,
  sessionId,
  { enabled = true } = {}
) {
  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: queryKeys.urlTracking.sessionActivities(
      teamId,
      userId,
      sessionId
    ),
    queryFn: () => fetchSessionUrlActivities(db, { teamId, userId, sessionId }),
    enabled: Boolean(teamId && userId && sessionId && enabled),
    staleTime: STALE_MS,
  });

  return { data, isLoading, isError, error: error || null };
}
